import { render } from "./CopySettingsModal.vue?vue&type=template&id=a0c2625c"
import script from "./CopySettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CopySettingsModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/CopySettingsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0c2625c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0c2625c', __exports__)) {
    api.reload('a0c2625c', __exports__)
  }
  
  module.hot.accept("./CopySettingsModal.vue?vue&type=template&id=a0c2625c", () => {
    api.rerender('a0c2625c', render)
  })

}


export default __exports__